module.exports = __webpack_public_path__ + "static/media/DS2Logo.ca9f249b.jpg";